/**
 * @file Layer.js.
 * @author Sérgio Ferraz Souza <todentro@gmail.com>
 * @copyright Cognatis GeoAnalytics & Big Data Ltda :: 2020
 */

import Request from '../components/http/request'
import Service from './Service'

const defaultJsonHeaders = {
  headers: {
    'Content-Type': 'application/json'
  }
}

/**
 * Layer Management Service
 * @class
 */
class Layer extends Service {
  constructor (options, resource) {
    super(options)
    this.resource = resource
    this.request = new Request({tag: 'das'})
    // this.request = new Request({environment: 'local', tag: 'das'})
  }

    /**
     * Get Primary Key By Layer
     *
     * @async
     * @function Get Menus
     * @param {Number} layerId - Layer Id
     * @return {Promise<json>} The json with the geoLevels
     */
    async getPrimaryKey (layerId) {
        return new Promise((resolve, reject) => {
        if (typeof environmentId === 'undefined') reject(new Error('Esperado o identificador do ambiente'))
        console.log('### GET MENU ###')
        let endPoint = `/layer/getprimarykey/${layerId}`
        //let request = new Request({ environment: 'local', tag: 'das' })

        let req = new Request({tag: 'python'})
        req.get(endPoint, defaultJsonHeaders)
            .then(response => resolve(response))
            .catch(() => reject)
        })
    }






  /**
   * Creates a new layer that is a copy of the current instance
   * @async
   * @function getRowCount
   * @param {Number} layerId - Target layer id
   * @param {Object} cloneOptions - Clone options
   * @returns {Promise<void>}
   */
  async cloneLayer (layerId, cloneOptions = {}) {
    return new Promise((resolve, reject) => {
      if (Object.keys(cloneOptions).length === 0) reject(new Error('Esperado o cloneOptions'))
      const endPoint = `/api/0.1-a/layer/${layerId}/clone`
      this.request.post(endPoint, cloneOptions, defaultJsonHeaders)
        .then(res => resolve(res))
        .catch(() => reject)
    })
  }
  /**
   * Count the number of rows in a layer
   *
   * @async
   * @function getRowCount
   * @param {Object} layer - Target layer
   * @param {Array} bounds - Map view port
   * @return {Promise<json>} The json with the result
   */
  async getRowCount (layer = {}, bounds = []) {
    return new Promise((resolve, reject) => {
      if (typeof layer === 'undefined') reject(new Error('Esperado o layer'))
      if (typeof bounds === 'undefined') reject(new Error('Esperado o bbox'))
      if (!Array.isArray(bounds)) reject(new Error('Esperado o bbox'))
      const rule = layer.jbQuery && layer.jbQuery.hasOwnProperty('query') ? layer.jbQuery.query.Postgresql : null
      const endPoint = `/api/0.1-a/layer/rownumber`
      const data = {
        rule: rule,
        bounds: bounds,
        layerId: layer.objectid
      }
      this.request.post(endPoint, data, defaultJsonHeaders)
        .then(res => resolve(res))
        .catch(() => reject)
    })
  }

  /**
   * Get Geometry
   *
   * @async
   * @function Get Search Address Result
   * @param {string} SchemaName
   * @param {string} TableName
   * @param {string} KeyColumn PK Name
   * @param {string} PkValue
   * @return {Promise<json>} The json with the result
   */
  async getGeometry (SchemaName, TableName, KeyColumn, PkValue) {
    return new Promise((resolve, reject) => {
      let endPoint = `/api/0.1-a/geometry/GetCentroidGeometry?schemaName=${SchemaName}&tableName=${TableName}&Key=${KeyColumn}&Value=${PkValue}`
      //this.request = new Request({environment:'local', tag: 'das'})
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }






  /**
   * Get Geometry
   *
   * @async
   * @function Get Layer Geolevel
   * @param {int} IdLayer
   * @return {Promise<json>} The json with the result
   */
  async getGeolevel (IdLayer) {
    return new Promise((resolve, reject) => {
      let endPoint = `/api/0.1-a/layer/getgeovel/${IdLayer}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }


  /**
   * Get Position
   *
   * @async
   * @function Get Layer GeolevelPosition
   * @param {int} IdLayer
   * @return {Promise<json>} The json with the result
   */
  async getGeolevelPosition (IdLayer) {
    return new Promise((resolve, reject) => {
      let endPoint = `/api/0.1-a/layer/getgeovelposition/${IdLayer}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }


  /**
   * Get column metadata
   *
   * @async
   * @function Get Search Address Result
   * @param {string} textQuery
   * @return {Promise<json>} The json with the result
   */
  async getSearchAdress (textQuery) {
    return new Promise((resolve, reject) => {
      if (typeof textQuery === 'undefined') reject(new Error('Esperado o identificador do textQuery'))
      let endPoint = `/api/0.1-a/QueryBuilder/searchadress/${textQuery}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }
  /**
   * Recebe uma lista de Endereços de acordo com o texto e o Geolevel informado
   *
   * @async
   * @function Get Search Address Result
   * @param {string} textQuery
   * @param {int} geolevelid
   * @return {Promise<json>} The json with the result
   */
  async getSearchAdress (textQuery,geolevelId) {
    return new Promise((resolve, reject) => {
      if (typeof textQuery === 'undefined') reject(new Error('Esperado o identificador do textQuery'))
      let endPoint = `/api/0.1-a/QueryBuilder/searchAdressByArea/${textQuery}/${geolevelId}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }

  /**
   * Traz Areas que pode ser usadas no filtro Onde
   *
   * @async
   * @function Get Search Address Result
   * @param {string} textQuery
   * @param {int} geolevelid
   * @return {Promise<json>} The json with the result
   */
  async whereFilterAreas (environmentId) {
    return new Promise((resolve, reject) => {
      if (typeof environmentId === 'undefined') reject(new Error('Esperado o identificador do ambiente'))
      let endPoint = `/api/0.1-a/GeolevelGroup/GetWhereFilterAreas/${environmentId}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }


  /**
   * Busca Todas Areas dos Endereços Poligonais
   *
   * @async
   * @function Get Search Address Result
   * @param {string} textQuery
   * @return {Promise<json>} The json with the result
   */
  async getAllAreas (textQuery) {
    return new Promise((resolve, reject) => {
      if (typeof textQuery === 'undefined') reject(new Error('Esperado o identificador do textQuery'))
      let endPoint = `/api/0.1-a/QueryBuilder/searchallareatype/${textQuery}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }

  /**
   * Busca por CNAE DESC
   *
   * @async
   * @function Get Search Address Result
   * @param {string} textQuery
   * @return {Promise<json>} The json with the result
   */
  async getSearchCnaeDesc (textQuery) {
    return new Promise((resolve, reject) => {
      if (typeof textQuery === 'undefined') reject(new Error('Esperado o identificador do textQuery'))
      let endPoint = `/api/0.1-a/QueryBuilder/searchcnae/${textQuery}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }

  /**
   * Busca por CNAE Cod
   *
   * @async
   * @function Get Search Address Result
   * @param {string} textQuery
   * @return {Promise<json>} The json with the result
   */
  async getSearchCnaeCod (textQuery) {
    return new Promise((resolve, reject) => {
      if (typeof textQuery === 'undefined') reject(new Error('Esperado o identificador do textQuery'))
      let endPoint = `/api/0.1-a/QueryBuilder/searchcnaecod/${textQuery}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }

  /**
   * Change layer dataviz in JbData field
   *
   * @async
   * @function changeDataViz
   * @param {Number} environment - Environment Id
   * @param {string} layerUid - Layer Uid
   * * @param {string} dataviz - DataViz type
   * @return {Promise<string>} The data from the URL.
   */
  async changeDataViz (environment, layerUid, dataviz = 'cluster') {
    return new Promise((resolve, reject) => {
      if (typeof environment === 'undefined') reject(new Error('Esperado o identificador do environment'))
      if (typeof layerUid === 'undefined') reject(new Error('Esperado o identificador do layer'))
      if (typeof dataviz === 'undefined') reject(new Error('Esperado o tipo do dataviz'))
      let endPoint = `/api/0.1-a/Layer/updatejbdata/${environment}/${layerUid}`
      let data = {'datavis': {'type': dataviz}}
      this.request.post(endPoint, data, defaultJsonHeaders)
        .then(response => resolve(response.data))
        .catch(() => reject)
    })
  }

  /**
   * Requisita via ENDPOINT o Layer pelo gdIdEvent da tabela
   * @date 2022-06-14
   * @param {number} layerUid Id do Layer
   */
  async getLayer (layerUid) {
    return new Promise((resolve, reject) => {
      const endPoint = `/api/0.1-a/layer/getuid/${layerUid}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(res => resolve(res.data))
        .catch(() => reject)
    })
  }
  /**
   * Requisita via ENDPOINT o Layer pelo gdIdEvent da tabela
   * @date 2022-06-14
   * @param {number} layerUid Id do Layer
   */
  async getLayerByUid (layerUid) {
    return new Promise((resolve, reject) => {
      const endPoint = `/api/0.1-a/layer/getuid/${layerUid}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(res => resolve(res))
        .catch(() => reject)
    })
  }



  /**
   * Change jbData field property
   *
   * @async
   * @function changeDataViz2
   * @param {Number} environment - Environment Id
   * @param {string} layerUid - Layer Uid
   * @param {Object} jbValue - jbData value to change
   * @return {Promise<string>} The data from the URL.
   */
  async changeDataViz2 (environment, layerUid, jbValue) {
    return new Promise((resolve, reject) => {
      if (typeof environment === 'undefined') reject(new Error('Esperado o identificador do environment'))
      if (typeof layerUid === 'undefined') reject(new Error('Esperado o identificador do layer'))
      if (typeof jbValue === 'undefined') reject(new Error('Esperado o valor do campo'))
      let endPoint = `/api/0.1-a/Layer/updatejbdata/${environment}/${layerUid}`
      this.request.post(endPoint, jbValue, defaultJsonHeaders)
        .then(response => resolve(response.data))
        .catch(() => reject)
    })
  }

  /**
   * Change jbData field property
   *
   * @async
   * @function Change jbData field property
   * @param {Number} environment - Environment Id
   * @param {string} layerUid - Layer Uid
   * @param {Object} jbValue - jbData value to change
   * @return {Promise<string>} The data from the URL.
   */
  async updateJbData (environment, layerUid, data) {
    return new Promise((resolve, reject) => {
      if (typeof environment === 'undefined') reject(new Error('Esperado o identificador do environment'))
      if (typeof layerUid === 'undefined') reject(new Error('Esperado o identificador do layer'))
      if (typeof data === 'undefined') reject(new Error('Esperado o campo data'))
      let endPoint = `/api/0.1-a/Layer/updatejbdata/${environment}/${layerUid}`
      this.request.post(endPoint, data, defaultJsonHeaders)
        .then(() => resolve())
        .catch(() => reject)
    })
  }

  /**
   * Create layer
   *
   * @async
   * @function create
   * @param {object} model - Model of the metadata
   * @return {Promise<json>} The json with layer created
   */
  async create (model) {
    return new Promise((resolve, reject) => {
      if (typeof model === 'undefined') reject(new Error('Esperado o modelo do layer'))
      let endPoint = `/api/0.1-a/Layer/${model.nIdEnvironment}`
      let config = {}
      this.request.post(endPoint, model, config)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }

  /**
   * Create layer for render user draw
   *
   * @async
   * @function createUserDraw
   * @param {object} model - Model of the metadata
   * @return {Promise<json>} The json with layer created
   */
  async createUserDraw (model) {
    return new Promise((resolve, reject) => {
      if (typeof model === 'undefined') reject(new Error('Esperado o modelo do layer'))
      const endPoint = `/api/0.1-a/layer/userdraw`
      const config = {}
      this.request.post(endPoint, model, config)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }

  /**
   * Delete render user draw by request
   *
   * @async
   * @function deleteUserDraw
   * @param {object} model - Model of the metadata
   * @return {Promise<json>} The json with layer created
   */
  async deleteUserDraw (requestId) {
    return new Promise((resolve, reject) => {
      if (typeof requestId === 'undefined') reject(new Error('Esperado o requestId da userdraw'))
      const endPoint = `/api/0.1-a/userdraw/userdraw/byrequestid/${requestId}`
      const config = {}
      this.request.delete(endPoint, defaultJsonHeaders)
        .then(response => resolve(response.data))
        .catch(() => reject)
    })
  }
  /**
   * Delete render user draw by id
   *
   * @async
   * @function deleteUserDrawbyId
   * @param {object} model - Model of the metadata
   * @return {Promise<json>} The json with layer created
   */
  async deleteUserDrawbyId (Id) {
    return new Promise((resolve, reject) => {
      if (typeof requestId === 'undefined') reject(new Error('Esperado o requestId da userdraw'))
      const endPoint = `/api/0.1-a/userdraw/userdraw/byid/${Id}`
      const config = {}
      this.request.delete(endPoint, defaultJsonHeaders)
        .then(response => resolve(response.data))
        .catch(() => reject)
    })
  }

  /**
   * Delete layer
   *
   * @async
   * @function delete
   * @param {Number} layerId - Layer Id
   * @return {Promise<string>} The data from the URL.
   */
  async delete (layerId) {
    return new Promise((resolve, reject) => {
      if (typeof layerId === 'undefined') reject(new Error('Esperado o identificador do layer'))
      let endPoint = `/api/0.1-a/layer/${layerId}`
      this.request.delete(endPoint, defaultJsonHeaders)
        .then(response => resolve(response.data))
        .catch(() => reject)
    })
  }

  /**
   * Get layers from environment
   *
   * @async
   * @function getAll
   * @param {Number} environment - Environment Id
   * @return {Promise<json>} The json with the layers
   */
  async getAll (environment) {
    return new Promise((resolve, reject) => {
      if (typeof environment === 'undefined') reject(new Error('Esperado o identificador do environment'))
      let endPoint = `/api/0.1-a/Layer/layers/${environment}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }

  /**
   * Get layers from environment
   *
   * @async
   * @function getAll
   * @param {Number} EnvironmentId - Environment Id
   * @param {Uid} UidLayer - UID
   * @param {Text}  ClassType- ClassType
   * @return {Promise<json>} The json with the layers
   */
  async getRootCategory (EnvironmentId, UidLayer, ClassType) {
    console.log('getRootCategory-endpoint')
    return new Promise((resolve, reject) => {
      if (typeof EnvironmentId === 'undefined') reject(new Error('Esperado o identificador do environment'))
      if (typeof UidLayer === 'undefined') reject(new Error('Esperado o identificador do environment'))
      let endPoint = `/api/0.1-a/Category/GetCategoryRoot/${EnvironmentId}/${UidLayer}/${ClassType}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }

  /**
   * Get layers from environment
   *
   * @async
   * @function getIcon
   * @param {Number} Id -  Id Icon
   * @return {Promise<json>} The json with the layers
   */
  async getIcon (Id) {
    return new Promise((resolve, reject) => {
      let endPoint = `/api/0.1-a/Category/geticon/${Id}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }
  /**
   * Get Category
   *
   * @async
   * @function getCategoryById
   * @param {Number} IdCategory -
   * @return {Promise<json>} The json with the layers
   */
  async getCategoryById (IdCategory) {
    return new Promise((resolve, reject) => {
      if (typeof IdCategory === 'undefined') reject(new Error('Esperado o identificador do IdCategory'))
      let endPoint = `/api/0.1-a/Category/GetCategoryById/${IdCategory}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }

  /**
   * Get layer columns
   *
   * @async
   * @function getColumns
   * @param {string} layerUid - Layer Uid
   * @return {Promise<json>} The json with the layers
   */
  async getColumns (layerUid) {
    return new Promise((resolve, reject) => {
      if (typeof layerUid === 'undefined') reject(new Error('Esperado o identificador do layer'))
      let endPoint = `/api/0.1-a/Layer/columns/${layerUid}?withRelations=true`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }

  /**
   * Get layer columns
   *
   * @async
   * @function getColumns2
   * @param {string} layerUid - Layer Uid
   * @return {Promise<json>} The json with the layers
   */
  async getColumns2 (layerUid) {
    return new Promise((resolve, reject) => {
      if (typeof layerUid === 'undefined') reject(new Error('Esperado o identificador do layer'))
      let endPoint = `/api/0.1-a/Layer/LayerColumns/${layerUid}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }

  /**
   * Get layer by id
   *
   * @async
   * @function getById
   * @param {Number} layerId - Layer Id
   * @return {Promise<json>} The json with the layer
   */
  async getById (layerId) {
    return new Promise((resolve, reject) => {
      if (typeof layerId === 'undefined') reject(new Error('Esperado o identificador do layer'))
      let endPoint = `/api/0.1-a/Layer/${layerId}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }

  /**
   * Get layer by uid
   *
   * @async
   * @function getByUid
   * @param {Number} environment - Environment Id
   * @param {string} layerUid - Layer Uid
   * @return {Promise<json>} The json with the layer
   */
  async getByUid (environment, layerUid) {
    // console.log('getByUid')
    return new Promise((resolve, reject) => {
      environment = -1
      if (typeof environment === 'undefined') reject(new Error('Esperado o identificador do environment'))
      if (typeof layerUid === 'undefined') reject(new Error('Esperado o identificador do layer'))
      let endPoint = `/api/0.1-a/Layer/GetLayer/${environment}/${layerUid}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }

  /**
   * Get DataViz
   *
   * @async
   * @function getByUid
   * @param {Number} environment - Environment Id
   * @param {string} layerUid - Layer Uid
   * @return {Promise<json>} The json with the layer
   */
  async getDataViz (uidLayer) {
    return new Promise((resolve, reject) => {
      if (typeof uidLayer === 'undefined') reject(new Error('Esperado o identificador do layer'))
      let endPoint = `/api/0.1-a/DataViz/mapbox/style/read/${uidLayer}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }

  /**
   * Insert DataViz to Layer
   *
   * @async
   * @function getByUid
   * @param {Number} environment - Environment Id
   * @param {string} layerUid - Layer Uid
   * @return {Promise<json>} The json with the layer
   */
  async insertDataViz (uidLayer, dataViz) {
    return new Promise((resolve, reject) => {
      if (typeof uidLayer === 'undefined') reject(new Error('Esperado o identificador do layer'))
      let endPoint = `/api/0.1-a/DataViz/mapbox/style/new/insert/${uidLayer}`
      this.request.post(endPoint, dataViz, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }

  async getLayerColumn (guid, environment, classType, alwaysOnTop = true) {
    return new Promise((resolve, reject) => {
      if (typeof guid === 'undefined') reject(new Error('Esperado o identificador do Layer'))
      if (typeof environment === 'undefined') reject(new Error('Esperado o identificador do ambiente'))
      if (typeof layer === 'undefined') reject(new Error('Esperado o identificador do layer'))
      let endPoint = `/api/0.1-a/ColumnChooser/${guid}/${environment}/${classType}/${alwaysOnTop}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response.data))
        .catch(() => reject)
    })
  }

  /**
   * Get layer primary key
   *
   * @async
   * @function getPrimaryKey
   * @param {string} layerUid - Layer Uid
   * @return {Promise<json>} The json with the result
   */
  async getPrimaryKey (layerUid) {
    return new Promise((resolve, reject) => {
      if (typeof layerUid === 'undefined') reject(new Error('Esperado o identificador do layer'))
      let endPoint = `/api/0.1-a/Layer/relation/${layerUid}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }

  /**
   * Get primary key
   *
   * @async
   * @function getPrimaryKey
   * @param {Number} objectid - Layer Id
   * @return {Promise<json>} The json with the result
   */
  async getPrimaryKey (objectid) {
    return new Promise((resolve, reject) => {
      if (typeof objectid === 'undefined') reject(new Error('Esperado o identificador do layer'))
      let endPoint = `/api/0.1-a/layer/${objectid}/primarykey`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }
  /**
   * Check if the name of layer is valid
   *
   * @async
   * @function rename
   * @param {Number} environment - Environment Id
   * @param {string} name - Layer name
   * @return {Promise<json>} The json with project updated
   */
  async isValidName (environment, name) {
    return new Promise((resolve, reject) => {
      if (typeof environment === 'undefined') reject(new Error('Esperado o identificador do environment'))
      if (typeof name === 'undefined') reject(new Error('Esperado o nome do layer'))
      const endPoint = `/api/0.1-a/Layer/isvalidname/${environment}/${name}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }

  /**
   * Refresh the layer source
   *
   * @async
   * @function sourceRefresh
   * @param {Number} objectId - Layer identifier
   * @return {Promise<json>} The json with project updated
   */
  async sourceRefresh (objectId) {
    return new Promise((resolve, reject) => {
      let endPoint = `/api/0.1-a/layer/${objectId}/refresh`
      this.request.put(endPoint, {}, defaultJsonHeaders)
        .then(res => resolve(res))
        .catch(() => reject)
    })
  }

  /**
   * Rename the layer
   *
   * @async
   * @function rename
   * @param {Number} environment - Environment Id
   * @param {string} layer - Layer Id
   * @param {string} name - Layer name
   * @return {Promise<json>} The json with project updated
   */
  async rename (environment, layer, name) {
    return new Promise((resolve, reject) => {
      if (typeof environment === 'undefined') reject(new Error('Esperado o identificador do ambiente'))
      if (typeof layer === 'undefined') reject(new Error('Esperado o identificador do layer'))
      let endPoint = `/api/0.1-a/layer/${layer}`
      let data = [
        {
          "value": name,
          "path": "/name",
          "op": "replace"
        }
      ]
      this.request.patch(endPoint, data, defaultJsonHeaders)
        .then(response => resolve(response.data))
        .catch(() => reject)
    })
  }

  async update (layer) {
    return new Promise((resolve, reject) => {
      if (typeof layer === 'undefined') reject(new Error('Esperado o identificador do layer'))
      let endPoint = `/api/0.1-a/Layer/Layer`
      this.request.put(endPoint, layer, {}, defaultJsonHeaders)
        .then(res => resolve(res))
        .catch(() => reject)
    })
  }

  /**
   * Partial update layer properties
   * @async
   * @function update2
   * @param {Number} id - Layer Id
   * @param {Array} model - Values to change
   * @return {Promise<Object>} The updated layer
   */
  async update2 (id, model) {
    return new Promise((resolve, reject) => {
      if (typeof id === 'undefined') reject(new Error('Esperado o identificador do layer'))
      if (typeof model === 'undefined') reject(new Error('Esperado o model'))
      if (!Array.isArray(model)) reject(new Error('"model" deve ser um array de elementos atualizáveis'))
      const endPoint = `/api/0.1-a/Layer/${id}`
      this.request.patch(endPoint, model, defaultJsonHeaders)
        .then(res => resolve(res))
        .catch(() => reject)
    })
  }

  /**
   * Change jbData field property
   *
   * @async
   * @function updateConfig
   * @param {Number} layerOid - Layer Id
   * @param {Number} environment - Environment Id
   * @param {string} tag - Property name to upsert
   * @param {Object} jbValue - jbData value to change
   * @return {Promise<string>} The data from the URL.
   */
  async updateConfig (layerOid, environment, tag, jbValue) {
    return new Promise((resolve, reject) => {
      if (typeof layerOid === 'undefined') reject(new Error('Esperado o identificador do layer'))
      if (typeof environment === 'undefined') reject(new Error('Esperado o identificador do environment'))
      if (typeof tag === 'undefined') reject(new Error('Esperado o nome da propriedade'))
      if (typeof jbValue === 'undefined') reject(new Error('Esperado o valor do campo'))
      const endPoint = `/api/0.1-a/Layer/${layerOid}/${environment}/config/${tag}`
      this.request.patch(endPoint, jbValue, defaultJsonHeaders)
        .then(response => resolve(response.data))
        .catch(() => reject)
    })
  }
}

export {Layer}
